export default __webpack_public_path__ + "static/media/a021-viewmore-en.4b708ea4.png";